import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FunctionComponent, PropsWithChildren } from 'react';

import classNames from 'classnames';
import classes from './SortableItem.module.scss';

export enum SortableItemTag {
  DIV = 'div',
  TR = 'tr',
}

interface SortableItemProps {
  id: number;
  className?: string;
  disabled?: boolean;
  as?: SortableItemTag;
}

export const SortableItem: FunctionComponent<PropsWithChildren<SortableItemProps>> = ({
  id,
  className,
  disabled,
  as: Tag = SortableItemTag.DIV,
  children,
}) => {
  const { setNodeRef, listeners, transform, transition, isDragging } = useSortable({
    id,
    ...(disabled && { disabled: { draggable: true, droppable: true } }),
  });

  return (
    <Tag
      ref={setNodeRef}
      className={classNames(
        classes['sortable-item'],
        { [classes['sortable-item--dragging']]: isDragging },
        className
      )}
      style={{ transform: CSS.Translate.toString(transform), transition }}
      {...listeners}
    >
      {children}
    </Tag>
  );
};
